<template>
  <div class="edit-meta-data">
    <div class="edit-meta-data__title">
      Edit Metadata
    </div>
    <div class="content-elements">
      <ContentScreenModeSelect
        class="edit-meta-data__screen-mode"
        @screen="mode = $event"
      />
      <template v-if="isPublished">
        <div
          v-stop-draggable
          class="content-elements__subtitle"
        >
          Published
        </div>
        <GoogleSerpSimulator
          class="content-elements__serp"
          :url="truncatedUrl"
          :full-url="content.url"
          :title="content.tag_title_current"
          :description="content.tag_meta_description_current"
          :mode="mode"
        />
      </template>
      <div
        v-stop-draggable
        class="content-elements__subtitle"
      >
        Baseline
      </div>
      <GoogleSerpSimulator
        class="content-elements__serp"
        :url="truncatedUrl"
        :full-url="content.url"
        :title="content.tag_title_baseline"
        :description="content.tag_meta_description_baseline"
        :mode="mode"
      />
      <div
        v-stop-draggable
        class="content-elements__subtitle"
      >
        Optimized
      </div>
      <GoogleSerpSimulator
        class="content-elements__serp"
        :url="truncatedUrl"
        :full-url="content.url"
        :title="recommendedTitle"
        :description="recommendedDescription"
        :mode="mode"
      />
      <RecommendedContent
        v-model="recommendedTitle"
        title="Title"
        class="content-elements__recommended"
        :max-length="60"
        :orange-zone="65"
        :min-length="20"
        type="title"
        single-line
        @change.once="isDirty = true"
      />
      <RecommendedContent
        v-model="recommendedDescription"
        class="content-elements__recommended"
        title="Meta Description"
        type="description"
        :max-length="160"
        :orang-zone="170"
        :min-length="100"
        @change.once="isDirty = true"
      />
    </div>
    <base-content-block
      title="Keyword Cloud"
      class="edit-meta-data__keyword-cloud"
    >
      <KeywordCloud />
    </base-content-block>
    <div class="content-elements">
      <div class="content-elements__controls">
        <button
          class="content-elements__button content-elements__button_cancel"
          @click.prevent="close()"
        >
          Cancel
        </button>
        <button
          class="content-elements__button content-elements__button_submit"
          @click.prevent="apply()"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import GoogleSerpSimulator from './GoogleSerpSimulator'
import ContentScreenModeSelect from './ContentScreenModeSelect'
import BaseModalMixins from '@/common/BaseModalMixins'
import KeywordCloud from '@/features/content-briefs/brief-content/KeywordCloud'
import _ from 'lodash'

export default {
  name: 'EditMetaData',
  components: {
    KeywordCloud,
    GoogleSerpSimulator,
    RecommendedContent: () => import('./RecommendedContent'),
    ContentScreenModeSelect
  },
  mixins: [BaseModalMixins],
  props: {
    content: {
      type: Object,
      required: true
    },
    recommendedTitleKey: {
      type: String,
      default: 'tag_title_recommended'
    },
    recommendedDescriptionKey: {
      type: String,
      default: 'tag_meta_description_recommended'
    }
  },
  data () {
    return {
      recommendedTitle: '',
      recommendedDescription: '',
      mode: 'desktop',
      isDirty: false,
    }
  },
  computed: {
    truncatedUrl () {
      if (!this.content.url) {
        return this.content.url
      }
      // remove protocol here
      const truncateUrl = this.content.url.replace(/(^\w+:|^)\/\//, '')
      if (truncateUrl.length <= 60) {
        return truncateUrl
      }
      const splitedUrl = truncateUrl.split('/')
      const lastSymbolsCount = 57 - splitedUrl[0].length
      return `${splitedUrl[0]}...${truncateUrl.slice(truncateUrl.length - lastSymbolsCount)}`
    },
    isPublished () {
      return _.get(this.content, 'url_status', '').toLowerCase() === 'published'
    }
  },
  watch: {
    content: {
      handler (value) {
        if (value) {
          if (!this.isDirty) {
            this.recommendedTitle = value[this.recommendedTitleKey] || this.recommendedTitle
            this.recommendedDescription = value[this.recommendedDescriptionKey] || this.recommendedDescription
          }
        }
      },
      immediate: true
    }
  },
  methods: {
    close () {
      this.$emit('close')
    },
    apply () {
      this.$emit('close', {
        recommendedTitle: this.recommendedTitle,
        recommendedDescription: this.recommendedDescription
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .edit-meta-data {
    padding: 40px;

    &__title {
      font-size: 32px;
      color: $rfx-dark-march;
      line-height: 48px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 0 auto 24px;
      letter-spacing: -0.32px;
      font-weight: bold;
    }

    &__screen-mode {
      display: flex;
      justify-content: flex-end;
      cursor: pointer;
    }

    &__keyword-cloud {
      margin-top: 24px;
    }

    .content-elements {
      padding: 0;

      &__recommended {
        margin-top: 24px;
      }

      &__controls {
        margin-top: 40px;
      }
    }
  }
</style>
